export const translations = {
  en: {
    navBar: {
      aboutMe: "About Me",
      projects: "Projects",
      contact: "Contact",
      resume: "Résumé",
    },
    landing: {
      intro:
        "Hi, my name is Florian Budniewski, and I work as a Web Developer in Japan.",
      button: "Learn more",
    },
    aboutMe: {
      aboutMe1: {
        header: "It all started as a dream...",
        text: "Graduated from an Engineering school in France, I have decided to quit my job as a Research & Development Engineer in the industry of filtration after 3 years, to follow my long-time dream to come and live in Japan",
      },
      aboutMe2: {
        header: "Improve to Survive",
        text: "Self-taught Front-End Web Developer, I have started learning the fundamentals of Web Development in December 2022, and since then, I have never stopped learning and sharpening my skills day after day",
      },
      aboutMe3: {
        header: "Never Settle",
        text: "My goal is to reach a near perfection state in everything I engage myself in. Becoming a reliable, smart and trustworthy human is the never-ending, life-long quest I am pursuing. To me, it begins with an open-mind, a social and emotional intelligence, as well as a strong will to actually make things change",
      },
    },
    projects: {
      header: "Projects",
      shareHouseManager:
        "Life in a Share House is full of situations that sometimes require a great deal of organisation. Share House Manager is an app developed with ViteJS/VueJS to provide the best visual interface, without compromising the fluidity of the application. The use of a new-generation database like Firebase guarantees reliable data traffic that's also easy to maintain.",
      omotebike:
        "A NextJS web app to manage and keep track of the shared bike of a share house. Easy to use, it allows the users to know exactly when someone used the bike, or when the bike is not available !",
      promptopia:
        "Share your best ChatGPT prompts with the Promptopia community ! Sign in using your Google account, then post and edit your best AI prompts with other users. This app is made using NextJS to ensure fast page & image loading times, as well as easy website routing.",
      omotesando:
        "A simple website, with a practical use ! Managing chores in a place like a sharehouse is not always easy. The House Companion gives information regarding rubbish sorting to the weekly duos on duty !",
      robofriends:
        "A basic ReactJS App that I have made following a tutorial in the Zero To Mastery program. The app makes individual cards for every customer / robot with their personal information. The search bar is updated dynamically when the user types something in it.",
      backgroundGenerator:
        "Make your own color gradient using this simple website, and copy-paste the CSS property to put us it in your own websites ! So useful that I actually used it to make this website's backgrounds !",
      portfolio:
        "The website you are actually browsing at the very moment ! I tried to use new things such as file download, new CSS properties and design in a more general way. Hope you like it !",
      facetoface:
        "A ReactJS app that allows you to detect a face inside an image by providing a URL to it. You first have to register to create your own profile, then scan as many face images that you want !",
      buttons: {
        visit: "Visit Website",
        github: "See source code",
      },
      tools: "Used tools",
    },
    contact: {
      header: "Let's get in touch !",
      text: `" I am looking forward to working on exciting new projects, and be part of a team that shares common values. Together, let's do our best ! "`,
      nameSpan: "Florian Budniewski",
    },
    footer: {
      text: "Website made by Florian Budniewski",
    },
  },
  jp: {
    navBar: {
      aboutMe: "自己紹介",
      projects: "プロジェクト",
      contact: "連絡",
      resume: "履歴書",
    },
    landing: {
      intro:
        "はじめまして、Florian Budniewskiと申します。日本でWebデベロッパーとして働いています。",
      button: "もっと",
    },
    aboutMe: {
      aboutMe1: {
        header: "すべては、夢から始まった...",
        text: "フランスの工学部を卒業後、長年の夢であった日本での生活を実現するため、3年間勤めたろ過業界の研究開発エンジニアを退職することにしました",
      },
      aboutMe2: {
        header: "生き残るための改善",
        text: "独学でフロントエンドWebデベロッパーを目指し、2022年12月からWeb開発の基礎を学び始め、以来、日々、学びと研鑽を欠かさない",
      },
      aboutMe3: {
        header: "改善を目指す",
        text: "私の目標は、すべてのことに完璧に近い状態で取り組むことです。信頼できる、賢い、信用できる人間になることが、私の追い求める終わりのない生涯の探求です。それは、オープンマインド、社会的・感情的知性、そして実際に物事を変えていこうとする強い意志から始まるのです",
      },
    },
    projects: {
      header: "プロジェクト",
      shareHouseManager:
        "シェアハウスでの生活は、時に整理整頓が必要な場面で溢れています。Share House ManagerはViteJS/VueJSで開発されたアプリで、アプリケーションの流動性を損なうことなく、最高のビジュアルインターフェースを提供します。Firebaseのような新世代のデータベースを使用することで、信頼性の高いデータトラフィックを保証し、メンテナンスも簡単になります。",
      omotebike:
        "シェアハウスのシェアバイクを管理・追跡するためのNextJSのWebアプリです。使いやすく、いつ誰かが自転車を使いましたか、いつ自転車が使えなくなりましたかを正確に知ることができます！",
      promptopia:
        "最高のChatGPTプロンプトをPromptopiaのコミュニティと共有しませんか？Googleアカウントでログインし、最高のAIプロンプトを他のユーザーと投稿・編集できます。このアプリはNextJSを使用しており、ページと画像の読み込み時間が速く、ウェブサイトのルーティングも効率的です。",
      omotesando:
        "シンプルなウェブサイトで、実用的な使い方を！シェアハウスのような場所での家事管理は、必ずしも簡単ではありません。ハウスコンパニオンは、ゴミの分別に関する情報を週番の2人組に伝えています！",
      robofriends:
        "Zero To Masteryプログラムのチュートリアルに沿って作った、基本的なReactJSアプリです。このアプリは、顧客やロボットの個人情報を記載したカードを作成します。検索バーは、ユーザーが何かを入力すると、動的に更新されます",
      backgroundGenerator:
        "このシンプルなウェブサイトを使って、自分だけのカラーグラデーションを作り、CSSプロパティをコピーペーストして、自分のウェブサイトに貼り付けましょう！とても便利なので、実際にこのサイトの背景を作るのに使ってみました！",
      portfolio:
        "あなたが今現在、実際に閲覧しているウェブサイトです！ファイルのダウンロード、新しいCSSプロパティ、より一般的な方法でのデザインなど、新しいものを使ってみました。あなたがそれを好むことを願っています！",
      facetoface:
        "画像に含まれる顔をURLで検出できるReactJSアプリです。登録をして自分のプロフィールを作成し、好きなだけ顔画像をスキャンできます！",
      buttons: {
        visit: "ホームページを見る",
        github: "ソースコードを見る",
      },
      tools: "使用したツール",
    },
    contact: {
      header: "連絡を取り合いましょう ！",
      text: `" 私は、エキサイティングな新しいプロジェクトに取り組み、共通の価値観を持つチームの一員となることを楽しみにしています。一緒に、ベストを尽くしましょう！ "`,
      nameSpan: "Florian Budniewski",
    },
    footer: {
      text: "Website made by Florian Budniewski",
    },
  },
  fr: {
    navBar: {
      aboutMe: "A propos",
      projects: "Projets",
      contact: "Contact",
      resume: "CV",
    },
    landing: {
      intro:
        "Bonjour, je suis Florian Budniewski, et je travaille en tant que développeur Web au Japon.",
      button: "En savoir plus",
    },
    aboutMe: {
      aboutMe1: {
        header: "Tout à commencé par un rêve...",
        text: "Diplômé d'une école d'ingénieur en France, j'ai décidé de quitter mon poste d'ingénieur R&D dans l'industrie de la filtration industrielle, pour poursuivre mon rêve de vivre et travailler au Japon.",
      },
      aboutMe2: {
        header: "Devenir meilleur pour survivre",
        text: "Développeur Web autodidacte, j'ai commencé à apprendre les fondamentaux du développement Web en Décembre 2022, et depuis je n'ai cessé d'apprendre et de de m'améliorer jour après jour.",
      },
      aboutMe3: {
        header: "Ne jamais se contenter",
        text: "Je vise la perfection dans tout ce que j'entreprends. Devenir une personne de confiance, intelligente et ouverte d'esprit, est la longue quête sur laquelle je me suis aventuré. Cela commence par une ouverture aux autres et ce qui m'entoure, une grande intelligence émotionnelle, et une forte volonté de vouloir vraiment faire bouger les choses.",
      },
    },
    projects: {
      header: "Projets",
      shareHouseManager:
        "La vie en Share House est pleine de situations qui nécessitent parfois de bien s'organiser. Le Share House Manager est une app développée avec ViteJS/VueJS afin d'apporter la meilleure interface visuelle, sans compromettre la fluidité de l'application. L'utilisation d'une base de données nouvelle génération comme Firebase garantit un traffic de données fiables et facile à maintenir",
      omotebike:
        "Une web app réalisée avec NextJS. Elle permet de manager l'utilisation d'un vélo commun dans une share house, avec une interface simple d'utilisation, ainsi qu'un historique permettant de retracer qui à utilisé le vélo par le passé !",
      promptopia:
        "Partagez vos meilleurs prompts ChatGPT avec la communauté Promptopia ! Enregistrez vous via votre compte Google, et commencez à poster ou éditer vos meilleurs prompts IA. Cette app a été créé en utilisant NextJS, permettant un chargement de page et d'images rapides, ainsi qu'un routing de pages plus efficace",
      omotesando:
        "Un site internet simple, avec une utilisation concrète ! Gérer les rotations de corvées dans une grande colocation n'est pas toujours simple. Heureusement, ce site nous donne des informations claires et en temps réel sur le tri des déchets, ainsi que sur les duos responsables hebdomadaire .",
      robofriends:
        "Une application ReactJS basique, que j'ai réalisée en suivant le programme ZeroToMastery. Le site créé des cartes individuelles pour chaque client-robot, avec leurs informations personnelles. La barre de recherche est actualisée dynamiquement chaque fois qu'on y entre quelquechose.",
      backgroundGenerator:
        "Réalisez vos propres gradients de couleurs réutilisables en CSS ! Il suffit de sélectionner deux couleurs, l'orientation souhaitée. Copiez-collez la ligne en CSS et le tour est joué ! Tellement pratique que je m'en suis servi pour la réalisation de ce portfolio !",
      portfolio:
        "Le site que vous êtes actuellement en train de visiter ! J'ai essayé d'incorporer de nouvelles fonctionnalités comme le téléchargement de fichier, une interface multi-langage, et plus généralement une conception graphique avec de nouveaux effets CSS. J'espère qu'il vous plaira !",
      facetoface:
        "FacetoFace est une app ReactJS permettant de détecter le visage d'une image en insérant l'URL dans le champ prévu à cet effet. Vous devrez d'abord vous enregistrer pour créer votre compte, puis vous pourrez scanner autant d'images que vous le souhaitez !",
      buttons: {
        visit: "Visiter le site",
        github: "Voir le code source",
      },
      tools: "Outils utilisés",
    },
    contact: {
      header: "Entrons en contact !",
      text: `"Je suis impatient et excité à l'idée de travailler sur de nouveaux projets au sein d'une équipe qui partage des valeurs communes. Ensemble, donnons le meilleur de nous-mêmes ! "`,
      nameSpan: "Florian Budniewski",
    },
    footer: {
      text: "Website made by Florian Budniewski",
    },
  },
};
